import React from "react";
import { FormGroup, Col, Row, Container } from "react-bootstrap";
import { connect } from "react-redux";

import { Button } from "components";

import styles from "./forgotPasswordSuccess.module.scss";

class ForgotPasswordSuccessPage extends React.Component {
	constructor(props) {
		super(props);
		if (!this.props.showForgotPasswordSuccessPage) {
			this.props.history.push("/");
		}
		this.okClick = this.okClick.bind(this);
	}

	okClick() {
		this.props.history.push("/");
	}

	render() {
		return (
			<Container>
				<Row className={styles.login}>
					<Col
						className={styles.loginBlock + " align-self-center"}
						md={{ span: 8, offset: 2 }}
					>
						<Col md={{ span: 8, offset: 2 }}>
							<div className={styles.welcomBlock}>
								<span className={styles.messageBlock}>
									<h2>
										<b>Check your mailbox</b>
									</h2>
									<div>
										We sent a password reset link to your
										email.
									</div>
								</span>
							</div>
							<FormGroup className="text-center">
								<Button
									onClick={this.okClick}
									className={styles.okBtn}
									value="Ok"
								/>
							</FormGroup>
						</Col>
					</Col>
				</Row>
			</Container>
		);
	}
}

function mapStateToProps(state) {
	return {
		showForgotPasswordSuccessPage: state.user.showForgotPasswordSuccessPage,
	};
}

const connectedForgotPasswordSuccessPage = connect(mapStateToProps)(
	ForgotPasswordSuccessPage,
);
export { connectedForgotPasswordSuccessPage as ForgotPasswordSuccessPage };
